export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  process.env.REACT_APP_API_ORIGIN ||
  "https://greenwich.am";

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  `${BACKEND_URL}/api`;

export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  BACKEND_URL;

export function resolveMediaUrl(path, fallback = null) {
  if (!path || path === "undefined" || path === "null") {
    return fallback;
  }

  if (typeof path !== "string") {
    return fallback;
  }

  if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("blob:")) {
    return path;
  }

  if (path.includes("/uploads/")) {
    const idx = path.indexOf("/uploads/");
    return `${BACKEND_URL}${path.substring(idx)}`;
  }

  if (path.includes("uploads/")) {
    const idx = path.indexOf("uploads/");
    return `${BACKEND_URL}/${path.substring(idx)}`;
  }

  if (path.startsWith("/")) {
    return `${BACKEND_URL}${path}`;
  }

  return `${BACKEND_URL}/uploads/${path}`;
}

export function resolveApiUrl(path) {
  if (!path) return API_BASE_URL;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return path.startsWith("/") ? `${API_BASE_URL}${path}` : `${API_BASE_URL}/${path}`;
}
